<template>
  <Metronome />
</template>

<script setup lang="ts">
import Metronome from '@/components/Metronome.vue'
</script>
